import { push } from "connected-react-router";
import React, { 
    useEffect, 
    useState } from "react";
import {connect } from 'react-redux';
import {
    REQUEST_STATUS, 
    RJSC_PAGE_LINK, 
    ROUTE_PATH 
} from "../../app/constants";
import { ERROR_STRING } from "../../app/errors";
import { Button, Header, NavigationLinkButton, Paragraph } from "../../components/RegularComponents";
import { rjscSearchSelect } from "../../redux/selector/rjscSearchSelector";
// import { setHasWorkExperience } from "../../redux/slice/mraApplicationSlice";
import { 
    fetchRjscDetails, 
    setRjscAdvanceSearchResponse, 
    setRjscAdvanceSearchString, 
    setRjscSearchStatus, 
    setRjscSearchString, 
    setRjscSearchStringType 
} from "../../redux/slice/rjscSearchSlice";
// import styles from './mra.module.scss';

const MraRJSCSearch = (props) => {
    const {rjscSearch, dispatch} = props
    const {searchStatus} = rjscSearch
    const [rjscNumberText, setRjscNumberText] = useState("")
    const [rjscNameText, setRjscNameText] = useState("")

    const [showNoStringError, setShowNoStringError] = useState(false)
    const [showNoResultError, setShowNoResultError] = useState(false)

    const resetErrorStatus = () => { 
        if(showNoResultError) {
            setShowNoResultError(false)
        }

        if(showNoStringError) { 
            setShowNoStringError(false)
        }
    }

    const onRjscNumberTextChange = (e) => {
        setRjscNumberText(e.target.value)
        resetErrorStatus()
    }

    const onRjscNameTextChange = (e) => {
        setRjscNameText(e.target.value)
        resetErrorStatus()
    }

     useEffect(() => {
        if(searchStatus === REQUEST_STATUS.SUCCESS) {
            if(rjscSearch.searchResponseData &&
                Array.isArray(rjscSearch.searchResponseData) && 
                rjscSearch.searchResponseData.length > 0) {

                if(rjscNumberText && rjscSearch.searchResponseData.length === 1) {

                    // The response contains only the basic information. 
                    // Fetch the complete reponse for the given registry number and then 
                    // move to the next screeen.

                    const resp = rjscSearch.searchResponseData[0]
                    const {registryNumber} = resp

                    dispatch(setRjscAdvanceSearchString({searchText : registryNumber})) 
                    dispatch(setRjscAdvanceSearchResponse(rjscSearch.searchResponseData))
                    dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_OPERATING_NAME_SEARCH_SELECT}`))
                    // dispatch(fetchRjscFromNumberAndSetDetails(registryNumber))
                    //         .then(data => {
                    //             dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_DETAIL_REVIEW}`))
                    //             dispatch(setRjscSearchStatus(REQUEST_STATUS.IDLE))
                    //         })
                    
                } else {
                    dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_SEARCH_SELECT}`))
                    dispatch(setRjscSearchStatus(REQUEST_STATUS.IDLE))
                }
            } else if(!rjscSearch.searchResponseData || 
                (Array.isArray(rjscSearch.searchResponseData) && 
                    rjscSearch.searchResponseData.length === 0) ) { 
                    setShowNoResultError(true)
            }
        }
    },[
        searchStatus, 
        rjscSearch.searchResponseData, 
        dispatch, 
        rjscNumberText
    ])
    /*
     * search click handler. 
     * The function sets the search string to the store and invokes an API request to search the string.
     * The response handler will check the response and automatically navigate to the detail preview screen. 
     */
    const onSearchClick = (e) => {
        // fetch the search result & navigate to the next screen after handilng all scenarios
        let searchString = ''

        if(rjscNameText) { 
            dispatch(setRjscSearchStringType({searchType : "rjscSearchName"}))
            searchString = rjscNameText
        } else if(rjscNumberText) { 
            dispatch(setRjscSearchStringType({searchType : "rjscSearchNumber"}))
            searchString = rjscNumberText
        } else { 
            // show error
            setShowNoStringError(true)
            return
        }

        dispatch(setRjscSearchString({searchText : searchString}))
        dispatch(fetchRjscDetails(searchString))
    }

    const isShowError = () => { 
        return (
            searchStatus === REQUEST_STATUS.ERROR
            || showNoResultError
            || showNoStringError
        )
    }
    
    // const handleNext = hasWorkExperience => () => {
    //     dispatch(setHasWorkExperience(hasWorkExperience))

    //     const nextPath = hasWorkExperience ? ROUTE_PATH.MRA_IS_CANADA_RESIDENT : ROUTE_PATH.MRA_HAS_WORK_EXPERIENCE_NO
    //     dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`))
    // }

    return (
        <div className="container" >
            {/* Title */}
            <div className="row" >
                <div className="col-xs-12 col-lg-8">
                    <Header 
                        id="mra-find-business-header" 
                        header="Find your business"
                    />
                </div>
            </div>

            <div className="row" >
                <div className="col-xs-12 col-lg-8">
                    <Paragraph 
                        id="mra-find-business-para" 
                        text={[`Most businesses in Nova Scotia are required to have a Registry of Joint Stock Companies (RJSC) number. If you aren't sure what your number is, <a style="text-decoration:underline"  href="${RJSC_PAGE_LINK}" target="blank">visit the RJSC website</a> to find out.`]}
                    />
                </div>
            </div>

            <div className="row form-group">
                <div className="col-lg-8">
                    <div className={"form-group" + (showNoStringError ? " has-error" : "")}>
                        <label 
                            id="rjsc-search-name-label" 
                            className="control-label" 
                            htmlFor="rjsc-name-text">
                                {"Search by company's legal business name"}
                        </label>
                        <input 
                            id="rjsc-name-text" 
                            nameid="rjsc-name-text" 
                            className="form-control ns-input fw-20" 
                            type="text" 
                            value={rjscNameText} 
                            onInput={onRjscNameTextChange} 
                            style={{display: "inline"}}/>
                            {showNoStringError &&
                                <span style={{marginLeft : "5px"}}>
                                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                </span> 
                            }
                    </div>
                    <div className={"topMarginNormal bottomMarginNormal"}>{"Or"}</div>

                    <div className={"form-group" + (showNoStringError ? " has-error" : "")}>
                        <label 
                            id="rjsc-search-number-label" 
                            className="control-label" 
                            htmlFor="rjsc-number-text">
                                Search by <a style={{textDecoration: "underline"}} href={RJSC_PAGE_LINK} target="blank">Registry of Joint Stock Companies (RJSC) number. <i className="fa fa-question-circle"></i></a> 
                        </label>
                        <input 
                            id="rjsc-number-text" 
                            name="rjsc-number-text"
                            className="form-control ns-input fw-20" 
                            type="text" 
                            value={rjscNumberText} 
                            onInput={onRjscNumberTextChange} 
                            style={{display: "inline"}}/>
                            {showNoStringError &&
                                <span style={{marginLeft : "5px"}}>
                                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                </span> 
                            }
                    </div>
                </div>
            </div>
            <div className="row topMarginNormal">
                <div className={"col-lg-2 help-block" + (isShowError() ? " has-error" : "")}>
                    <Button 
                        id="rjsc-search-button"
                        text={"Next"}
                        showSpinner={searchStatus === REQUEST_STATUS.IN_PROGRESS}
                        buttonType={"regular_primary"}
                        onClick={onSearchClick}
                    />
                    {(isShowError()) && <span style={{marginLeft : "5px"}}>
                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    </span>}
                </div>
                <div style={{marginTop: "2px"}} className="col-lg-5">
                    <NavigationLinkButton 
                        onClick={() => {
                            // TODO navigate to screen to enter company details
                            dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_COMPANY_DETAIL}`))
                        }}
                        text="My company is exempt and doesn't have an RJSC number"
                    />
                </div>
            </div>
            {showNoStringError && <div className="row">
                <div className="col-lg-12 topMarginNormal">
                    <div className="has-error">
                        {ERROR_STRING.RJSC_SEARCH_NO_STRING}
                    </div>
                </div>
            </div>}
            {showNoResultError && <div className="row">
                <div className="col-lg-12 topMarginNormal">
                    <div className="has-error">
                        {ERROR_STRING.RJSC_SEARCH_NO_RESULT}
                    </div>
                </div>
            </div>}
            {searchStatus === REQUEST_STATUS.ERROR && <div className="row">
                <div className="col-lg-12 topMarginNormal">
                    <div className="has-error">
                        {ERROR_STRING.RJSC_SEARCH_REQUEST_FAILED}
                    </div>
                </div>
            </div>
            }
        </div>
    )
}

export default connect(rjscSearchSelect)(MraRJSCSearch)
